import React from 'react';
import styled from 'styled-components';
import { PortableText } from '@portabletext/react';
import sharedStyles from '@rsc/ui-components/styles';
import SupportIcon from '../../support-icon';

const Callout = styled.span`
  display: block;
  background: ${({ theme }) => theme.colors.callout};
  color: #262626;
  font-size: ${sharedStyles.fontSize['1xl']};
  font-weight: ${sharedStyles.fontWeight.bold};
  margin-bottom: 2rem;
  padding: 0.5rem;
  text-align: center;
`;

const AlphaList = styled.ol`
  ol > li {
    list-style-type: lower-alpha;
  }
`;

const TextIcon = styled.i`
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: ${sharedStyles.fontSize.base};
`;

const components = {
  list: {
    number: ({ children }) => <AlphaList>{children}</AlphaList>,
  },
  types: {
    supportIcon: ({ value }) => {
      return <TextIcon className={value?.iconType} />;
    },
    link: ({ value }) => {
      return <a href={value.href}>{value.caption}</a>;
    },
  },
  marks: {
    callout: ({ children }) => {
      return <Callout>{children}</Callout>;
    },
  },
};

function SupportArticleText({ text }) {
  return <PortableText value={text} components={components} />;
}

export default SupportArticleText;
